/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ARTICLE SENTIMENT V2 CONFIGURATION GENERAL REACTION COUNTS: STYLES --------------- ++++++++++ */
export default theme => ({
  reactioncounts: {

  }
});
